import { type Configuration } from '@azure/msal-browser';
import { ASPIRE_HOSTED } from '@Constants/runtimeConstants';
import { createMsalConfiguration as buildMsalConfiguration } from '@synqo/cloud-client-shared';

export const MSAL_AUTHORITY: string = import.meta.env.VITE_MSAL_AUTHORITY;
export const MSAL_CLIENT_ID: string = import.meta.env.VITE_MSAL_CLIENT_ID;
export const MSAL_SCOPES: string = import.meta.env.VITE_MSAL_SCOPES;

export const LOGIN_REQUEST = {
    scopes: [MSAL_SCOPES],
};

export const createMsalConfiguration = (clientId: string = MSAL_CLIENT_ID): Configuration =>
    buildMsalConfiguration({ authority: MSAL_AUTHORITY, clientId, logToConsole: ASPIRE_HOSTED });
